import { createApp } from 'vue'
import ElementPlus, { ElMessage } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './styles/print.css'
import './styles/mobile.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element Plus 在面板高度变化时会触发 ResizeObserver，属无害浏览器警告
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer))
      })
    }
  }
}

const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  console.error('[vue-error]', err, info)
  const message = err?.message || '操作失败，请重试'
  if (!String(message).includes('getComputedStyle')) {
    ElMessage.error(message)
  } else {
    ElMessage.warning('界面切换中发生异常，请关闭下拉框后重试')
  }
}

app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.use(store)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')
